import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  getMemberInfo,
  selectMemberInfo,
  getDocumentFile,
  getDocumentLinks,
} from "../../../state/ducks/member/index";
import { alertActions } from "../../../state/ducks/alert/index";

class MemberInfo extends Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.props
      .getMemberInfo()
      .finally(() => this.setState({ isLoading: false }));
  }

  renderMemberInfoLoading = () => (
    <div className="t-deliveryDocumentsLoading">
      <div className="t-deliveryDocumentsLoading-spinner" aria-hidden="true" />
      <p className="t-deliveryDocumentsLoading-text">Üyelik bilgileri yükleniyor</p>
      <p className="t-deliveryDocumentsLoading-subtext">
        Üyelik bilgileriniz hazırlanıyor, lütfen bekleyiniz.
      </p>
    </div>
  );

  getDocumentFile = (documentId) => {
    if (documentId === null) {
      this.props.showError(
        "Sözleşmeniz henüz yüklenmemiştir. Müşteri temsilcinizle görüşebilirsiniz."
      );
    } else {
      this.props.getDocumentLink(documentId);
    }
  };

  getMemberThemeClass = (orgTurId) => {
    if (orgTurId === 2) return "t-memberDetail-header--green";
    if (orgTurId === 3) return "t-memberDetail-header--orange";
    if (orgTurId === 1) return "t-memberDetail-header--blue";
    return "t-memberDetail-header--blue";
  };

  renderMemberIcon = (item) => {
    if (item.orgTurId === 2) {
      return <i className="t-icon-home1" aria-hidden="true" />;
    }

    if (item.orgTurId === 3) {
      return (
        <img
          src="/assets/img/svg/icon_kabe.svg"
          alt=""
          className="t-memberDetail-headerKabeIcon"
        />
      );
    }

    return <i className="t-icon-truck1" aria-hidden="true" />;
  };

  canOpenMemberDetail = (item) => {
    return (item.kaynak === 2 && item.statu === 6) || item.kaynak !== 2;
  };

  showContractButton = (item) => {
    return item.statu !== null && (item.statu === 3 || item.statu === 6);
  };

  renderMemberField = (label, value, options = {}) => {
    const { hidden = false, danger = false } = options;

    if (hidden) return null;

    return (
      <div className="t-memberInfo-field">
        <span className="t-memberInfo-fieldLabel">{label}</span>
        <span className={`t-memberInfo-fieldValue${danger ? " t-memberInfo-fieldValue--danger" : ""}`}>
          {value}
        </span>
      </div>
    );
  };

  renderMemberCard = (item) => {
    const hac = item.orgTurId === 3;
    const themeClass = this.getMemberThemeClass(item.orgTurId);
    const showPlannedDeliveryDate = item.kayitTuruId !== 10 && item.kayitTuruId !== 11;
    const showInstallmentDeferral =
      item.kayitTuruId !== 8 &&
      item.dondurulanAy !== "0" &&
      item.dondurulanAy !== null &&
      item.dondurulanAy !== 0;
    const showGroupOrDeferralRow =
      item.grupNo !== null ||
      (item.kayitTuruId !== 8 && showInstallmentDeferral);

    return (
      <article className={`t-memberInfo-card ${themeClass}`} key={item.id}>
        <div className="t-memberInfo-cardHeader">
          <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
            {this.renderMemberIcon(item)}
          </div>

          <div className="t-memberInfo-cardHeaderContent">
            <h2 className="t-memberInfo-cardTitle">{item.orgSis}</h2>
            <div className="t-memberInfo-cardBadges">
              <span className="t-memberDetail-headerBadge">
                Üye No:&nbsp;
                <NumberFormat
                  decimalSeparator={false}
                  thousandSeparator={"."}
                  value={item.uyeNo}
                  displayType={"text"}
                />
              </span>
            </div>
          </div>

          <div className="t-memberInfo-cardActions">
            {this.showContractButton(item) && (
              <button
                type="button"
                className="t-memberInfo-btn t-memberInfo-btn--secondary"
                onClick={() => this.getDocumentFile(item.dokumanId)}
              >
                <i className="t-icon-document-alt-stroke" aria-hidden="true" />
                <span>Sözleşme</span>
              </button>
            )}

            {this.canOpenMemberDetail(item) ? (
              <Link
                to={`/Home/MemberDetail/${item.id}`}
                className="t-memberInfo-btn t-memberInfo-btn--primary"
              >
                <span>Detaylar</span>
                <i className="t-icon-arrow-right2" aria-hidden="true" />
              </Link>
            ) : (
              <span className="t-memberInfo-btn t-memberInfo-btn--disabled">
                <span>Detaylar</span>
                <i className="t-icon-arrow-right2" aria-hidden="true" />
              </span>
            )}
          </div>
        </div>

        {item.cekilisSiraNo !== null && (
          <div className="t-memberInfo-drawBar">
            <span>Grup No: <strong>{item.cekilisGrupNo ?? "-"}</strong></span>
            <span>Sıra No: <strong>{item.cekilisSiraNo ?? "-"}</strong></span>
            <span>Çekiliş Tarihi: <strong>{item.cekilisTarih ?? "-"}</strong></span>
          </div>
        )}

        <div className="t-memberInfo-grid">
          {this.renderMemberField(
            "Kayıt Türü",
            item.kayitTuru,
            { danger: item.kayitTuruId === 8 }
          )}
          {this.renderMemberField(
            "Organizasyon Tutarı",
            <NumberFormat
              decimalSeparator={","}
              thousandSeparator={"."}
              suffix={hac ? " XAU" : " ₺"}
              value={item.orgTutar}
              displayType={"text"}
            />
          )}
          {this.renderMemberField("Başlangıç Tarihi", item.baslangicTarihi)}
          {this.renderMemberField(
            `${showPlannedDeliveryDate ? "Planlanan " : ""}Teslim Tarihi`,
            item.teslimTarihi,
            { hidden: item.kayitTuruId === 8 }
          )}
          {showGroupOrDeferralRow && this.renderMemberField(
            "Grup No",
            item.grupNo,
            { hidden: item.grupNo === null }
          )}
          {showGroupOrDeferralRow && this.renderMemberField(
            "Taksit Erteleme",
            `${item.dondurulanAy} Ay`,
            { hidden: !showInstallmentDeferral }
          )}
          {this.renderMemberField(
            "Ayrılma Tarihi",
            item.ayrilmaTarihi,
            {
              hidden: item.kayitTuruId !== 8 || item.ayrilmaTarihi === null || item.ayrilmaTarihi === ""
            }
          )}
        </div>

        {item.kayitTuruId === 12 && (
          <div className="t-memberInfo-notice">
            Ayrılma süreciniz sonlanana kadar üyeliğinize devam etme hakkınız bulunmaktadır.
            Devam etme düşünceniz yok ise ödeme yükümlülüğünüz bulunmamaktadır.
          </div>
        )}
      </article>
    );
  };

  render() {
    const { member } = this.props;
    const { isLoading } = this.state;

    return (
      <div style={{ background: "#f3f3f3" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Üyelik Bilgilerim</h1>
              <p className="t-memberInfo-pageSubtitle">
                Aktif üyeliklerinizi görüntüleyin ve detay sayfasına geçin.
              </p>
            </div>

            {isLoading
              ? this.renderMemberInfoLoading()
              : member.info && member.info.map((item) => this.renderMemberCard(item))}
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMemberInfo: () => dispatch(getMemberInfo()),
  getDocumentFile: (documentId) => dispatch(getDocumentFile(documentId)),
  getDocumentLink: (documentId) => dispatch(getDocumentLinks(documentId)),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberInfo);
